import { render, staticRenderFns } from "./PrivacyPolicyView.vue?vue&type=template&id=56c5db61&scoped=true&"
import script from "./PrivacyPolicyView.vue?vue&type=script&lang=js&"
export * from "./PrivacyPolicyView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c5db61",
  null
  
)

export default component.exports